import Layout from "@/views/layouts/DefaultLayout.vue"
import { createApp } from "vue"

import "@/assets/main.css"

const app = createApp(Layout)

// Router setup
import Router from "@/router/main.ts"

// Data fetching
import { VueQueryPlugin } from "@tanstack/vue-query"

// Pinia
import { createPinia } from "pinia"
const Pinia = createPinia()

// I18n loader
import { I18n } from "@/lib/i18n_instance"

// Spinner
import vue3Spinner from 'vue3-spinner'

app
  .use(Router)
  .use(VueQueryPlugin, {
    enableDevtoolsV6Plugin: true
  })
  .use(Pinia)
  .use(I18n)
  .use(vue3Spinner)
  .mount("#app-root")
